import { Spinner } from '@creditornot/cb-progress';
import { AuthStatus } from '@creditornot/wolt-auth';
import { useAuthState } from '@creditornot/wolt-auth/react';
import React, { ReactElement } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import styled from 'styled-components';

export const LoginRedirect = ({ location }: RouteProps) => {
  if (!location) {
    throw new Error(
      'Location object is missing. Is react-router configured with the correct History implementation (BrowserHistory)?',
    );
  }
  // TODO: These params are not actually passed along properly in `next`. Test with Purchase view for example
  const params = (typeof location.search === 'string' && location.search.replace('?', '&')) || '';
  return <Redirect to={{ pathname: '/login', search: `?next=${location.pathname}${params}` }} />;
};

const LoadingSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-block-start: 40px;
  padding-block-end: 40px;
`;

const Loading = () => (
  <LoadingSpinnerContainer>
    <Spinner size="large" />
  </LoadingSpinnerContainer>
);

const RouteWhenAuthenticated = (props: RouteProps) => {
  const { status } = useAuthState();
  const statusMap: Record<AuthStatus, () => ReactElement> = {
    'logged-out': () => <Route component={LoginRedirect} />,
    'logging-in': () => <Loading />,
    'logged-in': () => <Route {...props} />,
  };

  return statusMap[status]();
};

export default RouteWhenAuthenticated;
